import { useNavigate } from "react-router-dom";

import AdminRoutes from "Routes/Components/Admin";

import Button from "Components/Admin/Buttons";
import ProjectTitle from "Components/Admin/EventSelector";
import ProfileWidget from "Components/Admin/ProfileWidget";

import Item from "./Components/Item";
import * as S from "./styles";

import { useTheme } from "styled-components";

const Sidebar = ({ open, setOpen }) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const selectItem = (route) => {
    if (route && typeof route === "string") navigate(route);

    setOpen(false);
  };

  const getRoute = (routeName) => AdminRoutes[routeName];

  return (
    <S.Wrapper open={open}>
      <S.CampaignWrapper>
        <S.CampaignSelectorWrapper>
          <ProjectTitle />
        </S.CampaignSelectorWrapper>
      </S.CampaignWrapper>

      <S.ProfileWidgetWrapper>
        <ProfileWidget onClickOption={(route) => selectItem(route)} />
      </S.ProfileWidgetWrapper>

      <S.ToggleMenuTitle></S.ToggleMenuTitle>

      <S.Content>
        <S.ItemsListWrapper>
          <Item
            icon={getRoute("Dashboard").icon}
            text={getRoute("Dashboard").name}
            action={() => selectItem(getRoute("Dashboard").path)}
          />

          <Item
            icon={getRoute("ListProjects").icon}
            text="Gestão de Projetos"
            subItems={[
              {
                text: getRoute("ListProjects").name,
                action: () => selectItem(getRoute("ListProjects").path),
              },
              // Fila de aprovações (parte 4): é o destino do alerta do sino.
              {
                text: getRoute("PendingApprovals").name,
                action: () => selectItem(getRoute("PendingApprovals").path),
              },
            ]}
          />

          <Item
            icon={getRoute("ListSeletivas").icon}
            text="Gestão de Seletivas"
            subItems={[
              {
                text: getRoute("ListSeletivas").name,
                action: () => selectItem(getRoute("ListSeletivas").path),
              },
              {
                text: getRoute("CreateSeletiva").name,
                action: () => selectItem(getRoute("CreateSeletiva").path),
              },
            ]}
          />

          <Item
            icon={getRoute("ListParticipants").icon}
            text="Gestão de Proponentes"
            subItems={[
              {
                text: getRoute("ListParticipants").name,
                action: () => selectItem(getRoute("ListParticipants").path),
              },
              {
                text: getRoute("CreateParticipant").name,
                action: () => selectItem(getRoute("CreateParticipant").path),
              },
            ]}
          />

          <Item
            icon={getRoute("ListSponsors").icon}
            text="Gestão de Patrocinadores"
            subItems={[
              {
                text: getRoute("ListSponsors").name,
                action: () => selectItem(getRoute("ListSponsors").path),
              },
              {
                text: getRoute("CreateSponsor").name,
                action: () => selectItem(getRoute("CreateSponsor").path),
              },
            ]}
          />

          <Item
            icon={getRoute("ListUsers").icon}
            text="Gestão de Usuários"
            subItems={[
              {
                text: getRoute("ListUsers").name,
                action: () => selectItem(getRoute("ListUsers").path),
              },
              {
                text: getRoute("CreateUsers").name,
                action: () => selectItem(getRoute("CreateUsers").path),
              },
            ]}
          />

          <Item
            icon={getRoute("ListProductions").icon}
            text="Gestão de Produções"
            subItems={[
              {
                text: getRoute("ListProductions").name,
                action: () => selectItem(getRoute("ListProductions").path),
              },
              {
                text: getRoute("CreateProductions").name,
                action: () => selectItem(getRoute("CreateProductions").path),
              },
            ]}
          />

          <Item
            icon={getRoute("ListNotifications").icon}
            text="Notificações"
            subItems={[
              {
                text: getRoute("ListNotifications").name,
                action: () => selectItem(getRoute("ListNotifications").path),
              },
              {
                text: getRoute("CreateNotification").name,
                action: () => selectItem(getRoute("CreateNotification").path),
              },
              {
                text: getRoute("CreateNotificationType").name,
                action: () =>
                  selectItem(getRoute("CreateNotificationType").path),
              },
            ]}
          />

          <Item
            icon={getRoute("Configurations").icon}
            text={getRoute("Configurations").name}
            subItems={[
              {
                text: "E-mail",
                action: () => selectItem(getRoute("Configurations").path),
              },
              {
                text: "Central de notificações",
                action: () => selectItem(getRoute("NotificationCenter").path),
              },
            ]}
          />
        </S.ItemsListWrapper>
      </S.Content>
      <S.ButtonWrapper>
        <Button
          text="Sair"
          variant="light"
          type="button"
          icon={{
            name: "Logout",
            position: "left",
            color: theme.colors.neutral.white,
          }}
          outline
        />
      </S.ButtonWrapper>
    </S.Wrapper>
  );
};

export default Sidebar;
